<template>
    <div>
        <div v-if="data_loading" class="text-5xl text-grey-darkest text-center mt-32">
            <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
        </div>

        <div v-else>
            <div class="flex flex-wrap flex-lg-nowrap lg:justify-between">
                <div class="text-2xl text-grey-darkest mr-2 mb-2 mb-lg-0 block lg:inline w-full lg:w-auto">{{ list.name }}</div>
                <div class="d-flex align-items-center">
                    <button>
                        <a @click="editList(list)" class="hidden xl:inline border-2 border-teal bg-teal font-semibold p-2 text-white text-sm rounded-sm">
                            Edit List
                        </a>
                    </button>
                    <div class="dropdown open ml-3">
                        <button type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">
                            <svg class="fill-current h-4 w-4" enable-background="new 0 0 515.555 515.555"
                                 viewBox="0 0 515.555 515.555" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                <path
                                    d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                                <path
                                    d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
                            </svg>
                        </button>

                        <div class="dropdown-menu dropdown-menu-right">
                            <a class="dropdown-item" @click="exportList()">Export</a>
                            <a class="dropdown-item" @click="deleteList()" >Delete</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-white shadow-md rounded mb-6 mt-4 overflow-auto">
                <div v-if="list.object_type === 'company'">
                    <company
                        :available-columns="availableColumns"
                        :available-sort="availableSort"
                        :items="items"
                        :masks="masks"
                        :list="list"
                        :companyCustomFields="companyCustomFields"
                        :companyCustomFieldTypeConstants="companyCustomFieldTypeConstants"
                        :currentOrder="currentOrder"
                        v-on:sortingUpdated="sortByColumn"
                        v-on:columnsToExportUpdated="exportColumnsUpdated"
                    ></company>
                </div>
                <div v-else-if="list.object_type === 'project'">
                    <project
                        :available-columns="availableColumns"
                        :available-sort="availableSort"
                        :items="items"
                        :masks="masks"
                        :list="list"
                        :projectCustomFields="projectCustomFields"
                        :projectCustomFieldTypeConstants="projectCustomFieldTypeConstants"
                        :currentOrder="currentOrder"
                        :projectSalesBehaviors="projectSalesBehaviors"
                        v-on:sortingUpdated="sortByColumn"
                        v-on:columnsToExportUpdated="exportColumnsUpdated"
                        :fieldLabels="fieldLabels"
                    ></project>
                </div>
                <div v-else>
                    <contact
                        :available-columns="availableColumns"
                        :available-sort="availableSort"
                        :items="items"
                        :masks="masks"
                        :list="list"
                        :contactCustomFields="contactCustomFields"
                        :contactCustomFieldTypeConstants="contactCustomFieldTypeConstants"
                        :currentOrder="currentOrder"
                        :contactSalesBehaviors="contactSalesBehaviors"
                        :calendar="calendar"
                        v-on:sortingUpdated="sortByColumn"
                        v-on:columnsToExportUpdated="exportColumnsUpdated"
                    ></contact>
                </div>

            </div>
            <div  v-if="pagination && pagination.meta.total > pagination.meta.per_page" class="flex justify-center align-items-center">

                <div class="mr-3">
                    Total of {{ pagination.meta.total }} records
                </div>
                <b-pagination
                    @change="goToPage"
                    v-model="pagination.meta.current_page"
                    :total-rows="pagination.meta.total"
                    :per-page="pagination.meta.per_page"
                    first-text="First"
                    prev-text="Prev"
                    next-text="Next"
                    last-text="Last"
                >
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>

import Company from "./tables/company";
import Project from "./tables/project";
import Contact from "./tables/contact";
export default {
    name: 'list-detail',
    components: {Project, Company, Contact},
    props: [
        'list',
        'availableColumns',
        'availableSort',
        'masks',
        'companyCustomFields',
        'companyCustomFieldTypeConstants',
        'contactCustomFields',
        'contactCustomFieldTypeConstants',
        'contactSalesBehaviors',
        'calendar',
        'projectCustomFields',
        'projectCustomFieldTypeConstants',
        'projectSalesBehaviors',
        'fieldLabels',
    ],

    data() {
        return {
            items: [],
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            page: 1,
            currentOrder: {
                sortBy: 'name',
                direction: 'desc'
            },
            data_loading: true,
            columnsToExport: [],
        }
    },
    created() {
        this.fetchLists();
    },
    methods: {
        goToPage(page){
            this.page = page;
            this.fetchLists(this.page);
        },
        editList(list) {
            window.location = route('list-edit', {list: list.id});
        },
        fetchLists (page = 1) {
            const self = this;
            self.page = page;
            let params = {
                page: self.page,
                sortBy: self.currentOrder.sortBy,
                direction: self.currentOrder.direction
            };
            self.data_loading = true;

            axios.get(route('api.filterLists.show', {filterList: self.list.id}), {params}).then(({data}) => {
                self.data_loading = false;
                self.items = data.data;
                self.pagination = data
            })
        },
        showCompany(company) {
            window.location = route('company.show', {company:company.id});
        },
        deleteList() {
            let self = this;
            axios.delete(route('api.filterLists.destroy', {filterList: this.list.id})).then(response => {
                if (response.data.status) {
                    self.getToast(1000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    window.location = route('lists');
                } else {
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            })
        },
        exportColumnsUpdated(columns) {
            this.columnsToExport = columns
        },
        sortByColumn(sortOrder) {
            console.log(sortOrder)
            this.currentOrder = sortOrder
            this.fetchLists();
        },
        exportList() {
            let self = this;
            axios.post(route('api.lists.export-list', {filterList: this.list.id}), {
                'sortBy': self.currentOrder.sortBy,
                'direction': self.currentOrder.direction,
                "time_zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                "columns": self.columnsToExport.map(column => ({
                    name: column.name,
                    property_name: column.property_name
                })),
            }).then(response => {
                if (response.data.status) {
                    self.getToast(1000).fire({
                        type: 'success',
                        title: 'Your report is being processed and will be available soon on your notifications.'
                    });
                } else {
                    self.getToast().fire({
                        type: 'error',
                        title: 'You are not authorized to proceed with this action. Please contact your administrator.'
                    });
                }
            })
        }
    }
}
</script>

<style scoped>
tr {
    line-height: 2rem;
}
.pagination > li > a {
    color: #4dc0b5;
}

.pagination > li > a:hover {
    background-color: #4dc0b5 !important;
    color: white;
}

.bg-qualified {
    background-color: #00ff8f;
}

li.page-item.active > a {
    background-color: #4dc0b5 !important;
    border-color: #4dc0b5 !important;
}

a.page-link:focus {
    box-shadow: none;
}

.project-listing-dropdown-button {
    border-color: #14b1af !important;
    color: #14b1af !important;
}

.overflowStyle {
    overflow: auto;
}

.custom-height-class {
    height: 150px;
}

.project-listing-dropdown-button:hover,
.project-listing-dropdown-button:active,
.project-listing-dropdown-button:focus,
.project-listing-dropdown-button:visited,
.project-listing-dropdown-button:focus-visible,
.project-listing-dropdown-button:focus-within,
.project-listing-dropdown-button:target,
.project-listing-dropdown-button .show > .btn-outline-success.dropdown-toggle {
    border-color: #14b1af !important;
    color: #ffffff !important;
    background-color: #14b1af !important;
    box-shadow: none !important;
}

.add-view-button {
    font-size: 13px;
    color: #14b1af;
    margin: 8px;
    outline: unset;
}

.bulk-update-button {
    font-size: 15px;
    font-weight: normal;
    color: #14b1af;
}

tr:hover > td > span > input,
tr:hover > td > div > span > select,
tr:hover > td > div > span > input,
tr:hover > td > span > div > div > input,
tr:hover > td > div > span > div > div > input {
    background-color: #f1f5f8 !important;
}

tr > td > span > div.required-field-missing > input,
tr:hover > td > span > div.required-field-missing > input {
    background-color: #F78580 !important;
}

.required-field-missing {
    background: #F78580;
}

#project_index .fix-name-content {
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 10vw !important;
    display: block;
}

.inline_update_loading_class {
    position: absolute;
    top: 50%;
    left: 50%;
}

#project_index {
    border-collapse: collapse;
    border-spacing: 0px;
    overflow: scroll;
}

#project_index th.column-header-resize {
    padding: 0;
    margin: 0px;
}

#project_index th.column-header-resize div.column-resize {
    resize: horizontal;
    overflow: auto;
    min-width: 90%;
    margin: 0px;
    padding: 0px;
    display: block;
    border: 0;
}

#project_index td.td-text-overflow {
    overflow: hidden;
}

.pin-black {
    font-size: 16px !important;
}

.pin-red {
    font-size: 16px !important;
    color: red !important;;
}

.pin-project-highlighted {
    background-color: #fff5eb;
}
.custom-checkbox.check_current_checkbox{
    margin-left: 7px !important;
}
.custom-checkbox.check_current_checkbox2{
    margin-left: 16px !important;
}

.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff !important;
    background-color: #0068f8 !important;
    border-color: #0068f8 !important;
}
@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    select {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    #project_index .fix-name-content {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }
}

@media only screen
and (min-device-width: 768px)
and (max-device-width: 1024px)
and (orientation: portrait)
and (-webkit-min-device-pixel-ratio: 1) {
    td > span {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    select {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }

    #project_index .fix-name-content {
        white-space: nowrap;
        width: auto !important;
        display: block;
    }
}

.tooltip-inner {
    width: 100% !important;
    max-width: 700px;
    height: auto;
}
</style>
